"use client";

import { useState } from "react";
import { Button, Modal } from "@mantine/core";
import { useLocale } from "next-intl";
import SampleColorReport from "./SampleColorReport";
import { trackGizmo } from "@/lib/analytics";
import styles from "./sampleColorReport.module.css";

const labels: Record<string, string> = {
  en: "Explore the sample report", es: "Ver informe de ejemplo (en inglés)", pl: "Zobacz przykładowy raport (po angielsku)",
  fr: "Voir un exemple de rapport (en anglais)", pt: "Ver relatório de exemplo (em inglês)", it: "Vedi un report di esempio (in inglese)",
  id: "Lihat contoh laporan (bahasa Inggris)", hi: "रिपोर्ट का नमूना देखें (अंग्रेज़ी में)", ko: "샘플 보고서 보기 (영어)",
  ru: "Посмотреть пример отчёта (на английском)", de: "Beispielbericht ansehen (auf Englisch)",
};

export default function SampleReportButton({ source, preview = false, onContinue, continueLabel }: {
  source: string;
  preview?: boolean;
  onContinue?: () => void;
  continueLabel?: string;
}) {
  const [opened, setOpened] = useState(false);
  const locale = useLocale();
  const label = labels[locale] || labels.en;
  const open = () => { setOpened(true); trackGizmo("sample_report_open", { source, mode: "demo" }); };
  return <div className={preview ? styles.preview : undefined}>
    {preview ? <button type="button" onClick={open} className={styles.previewButton}><img src="/resultPreviews/drapes.webp" alt="" width={1100} height={581} /><span>{label} →</span></button>
      : <Button variant="subtle" color="#92204c" onClick={open} mt="sm" styles={{ label: { whiteSpace: "normal", textAlign: "left" }, root: { height: "auto", minHeight: 44 } }}>{label} →</Button>}
    <Modal opened={opened} onClose={() => setOpened(false)} title={label} size="min(1100px, calc(100vw - 2rem))" padding="lg" closeButtonProps={{ "aria-label": "Close sample report" }}>
      {opened && <SampleColorReport />}
      {onContinue && continueLabel && <div className={styles.continueBar}><Button fullWidth size="md" color="#b3265c" onClick={() => {
        setOpened(false);
        trackGizmo("sample_report_continue", { source, mode: "demo" });
        onContinue();
      }} styles={{ label: { whiteSpace: "normal" }, root: { height: "auto", minHeight: 48, paddingBlock: 10 } }}>{continueLabel} →</Button></div>}
    </Modal>
  </div>;
}
